// extracted by mini-css-extract-plugin
module.exports = {"gallery":"gallery-module--gallery--ks9Z7","button":"gallery-module--button--3TihB"};